import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-422377ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Color Utility", -1))
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block mb-2 text-slate-300" }, "HEX:", -1))
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block mb-2 text-slate-300" }, "RGB:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "color",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedColor) = $event)),
        class: "h-10 w-20 bg-transparent cursor-pointer border-none rounded"
      }, null, 512), [
        [_vModelText, _ctx.selectedColor]
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateRandomColor && _ctx.generateRandomColor(...args))),
        class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-2"
      }, " Random Color ")
    ]),
    _createElementVNode("div", {
      class: "color-display p-4 rounded mb-6 text-slate-900 font-medium font-mono",
      style: _normalizeStyle({ backgroundColor: _ctx.selectedColor })
    }, " Selected Color: " + _toDisplayString(_ctx.selectedColor) + " " + _toDisplayString(_ctx.selecteRgbColor), 5),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hexColor) = $event)),
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.convertToRGB && _ctx.convertToRGB(...args))),
        class: "w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 font-mono"
      }, null, 544), [
        [_vModelText, _ctx.hexColor]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rgbColor) = $event)),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.convertToHEX && _ctx.convertToHEX(...args))),
        class: "w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 font-mono"
      }, null, 544), [
        [_vModelText, _ctx.rgbColor]
      ])
    ]),
    _createElementVNode("div", {
      class: "color-display p-4 rounded",
      style: _normalizeStyle({ backgroundColor: _ctx.hexColor })
    }, " Display Color ", 4)
  ]))
}